import { render, staticRenderFns } from "./crmTagsDetail.vue?vue&type=template&id=382eee73&scoped=true"
import script from "./crmTagsDetail.vue?vue&type=script&lang=js"
export * from "./crmTagsDetail.vue?vue&type=script&lang=js"
import style0 from "./crmTagsDetail.vue?vue&type=style&index=0&id=382eee73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382eee73",
  null
  
)

export default component.exports